/** @format */

import { Component, Input, OnInit } from '@angular/core';

import { ExclusiveProductContent } from '../exclusive-product-content.interface';
import { FileService } from '@shared/data-access/services';
import { pdpJsonFileName } from '@pdp/data-access/constants';

import { HmfTextLinkComponent } from '@dsg-tech/homefield-angular';
import { SideNavComponent } from '@shared/components';

import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconBrandingDsgMono,
	homefieldIconNikeLogo
} from '@dsg-tech/homefield-angular-icons';
import { take } from 'rxjs/operators';

@Component({
	selector: 'pdp-exclusive-product-ad',
	templateUrl: './exclusive-product-ad.component.html',
	styleUrl: './exclusive-product-ad.component.scss',
	imports: [HomefieldIconLibraryModule, HmfTextLinkComponent, SideNavComponent]
})
export class ExclusiveProductAdComponent implements OnInit {
	@Input() brand: string;

	content: ExclusiveProductContent;

	constructor(
		public fileService: FileService,
		homefieldIconsLibraryService: HomefieldIconsLibraryService
	) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconNikeLogo,
			homefieldIconBrandingDsgMono
		]);
	}

	ngOnInit() {
		const EXCLUSIVE_CONTENT = this.fileService.getDataFileByType$(
			pdpJsonFileName.exclusiveContent,
			'json'
		);

		EXCLUSIVE_CONTENT.pipe(take(1)).subscribe((values) => {
			this.content = values[this.brand];
		});
	}
}
